import { render, staticRenderFns } from "./VehicleTypeDialogForm.vue?vue&type=template&id=327630c7&scoped=true"
import script from "./VehicleTypeDialogForm.vue?vue&type=script&lang=js"
export * from "./VehicleTypeDialogForm.vue?vue&type=script&lang=js"
import style0 from "./VehicleTypeDialogForm.vue?vue&type=style&index=0&id=327630c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327630c7",
  null
  
)

export default component.exports